import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import {
  Badge,
  Box,
  Grid,
  Grid2,
  MenuItem,
  Select,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import Checkout from "./Checkout";
import { useDispatch, useSelector } from "react-redux";
import { deleteAddToCartProducts } from "../../store/slice/Webshop.slice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));


export default function MessagePopup({ open, handleClose }) {
  const dispatch=useDispatch()
  const theme = useTheme();
  const {
    webshopSettings,
  } = useSelector((store) => store?.Webshop);

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <Box>
          {/* <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton> */}
        </Box>
        <DialogContent sx={{mt:2}}>
            <Box sx={{display:"flex",flexDirection:'column'}}>
                <Typography sx={{fontSize:"1.5rem",textAlign:'center'}}>
                    minimumOrderQuantity should be {webshopSettings?.minimumOrderQuantity}
                </Typography >
                <Box sx={{mt:2,display:'flex',gap:"1rem",justifyContent:'center',alignItems:'center'}}>
                    <Button variant="contained" sx={{backgroundColor:"#969BA0",color:"#fff"}} onClick={handleClose}>
                        OK
                    </Button>
                </Box>
            </Box>
        </DialogContent>
        <DialogActions></DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}